<template>
  <div class="w3-card" :style="'border:5px solid ' + (comment.meta.isAllJybed?'#c0e0e8':'#f0ccdd')">
    <div class="w3-theme-light">
  <!--
      <img src="../../assets/w3images/avatar3.png" alt="Avatar" class="w3-left w3-circle w3-margin-right" style="width:25px">
  -->
      <user-header v-bind:user="comment.meta.creator" />
    </div><br />
    <div>{{comment.title}}</div>
    <p class="w3-left-align">
      {{comment.body}}<br/>
      <comment-like-button v-bind:comment="comment" />
    </p>
    <div :style="'padding:10px'" v-if="comment.meta.statements && comment.meta.statements.length > 0">
      <span style='font-weight:bold'>Statements</span> <edit-button v-if="isEditable" v-bind:isEditing="false" @edit="editStatements()" />
      <convo-comment-statements v-bind:comment="comment" v-bind:convo="convo" />
    </div>
  </div>
</template>

<script>
  import ConvoComment from "./ConvoComment.ts";

  export default ConvoComment;
</script>
